module.exports = __webpack_public_path__ + "Simple-Line-Icons.6ac7320f709ffd2784b4.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.woff2?-i3a2kk
// module id = ../../../../../src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.woff2?-i3a2kk
// module chunks = styles